import { ArrowLeft } from '@outdoor-voices/ui';
import { KitContext } from './context';
import { memo, useContext } from 'react';
import css from './Back.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Back = /*#__PURE__*/memo(function () {
  var _useContext = useContext(KitContext),
      kit = _useContext.kit,
      setStep = _useContext.setStep;

  return /*#__PURE__*/_jsx("div", {
    className: css.root,
    children: /*#__PURE__*/_jsxs("button", {
      "aria-label": "Go back to the ".concat(kit.title, " overview screen"),
      className: css.back,
      onClick: function onClick() {
        return setStep(0);
      },
      type: "button",
      children: [/*#__PURE__*/_jsx(ArrowLeft, {}), " Back to ", kit.title]
    })
  });
});